export const ADMINLOGIN = 'ADMINLOGIN';
export const ADMINLOGOUT = 'ADMINLOGOUT';
